import { createFileRoute } from '@tanstack/react-router'
import { healthQueryOptions, newsSearchSchema } from '../../src/schemas/routeSchemas'

export const Route = createFileRoute('/news')({
  validateSearch: (search) => newsSearchSchema.parse(search),
  loaderDeps: () => ({}),
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(healthQueryOptions)
  },
  staticData: {
    englishAllowed: true,
    layout: 'menu',
  },
})
